export default __webpack_public_path__ + "static/media/phishing-indentify3.4f5f728c.png";